import { EntityTable } from '@/features/admin/EntityTable';

export function LocaisPage() {
  return (
    <EntityTable
      title="Locais"
      subtitle="Hierarquia física: prédios, andares, salas, prateleiras e carros"
      endpoint="/v1/locations"
      queryKey="locations"
      columns={[
        { key: 'code', label: 'Código', className: 'font-mono text-xs' },
        { key: 'name', label: 'Nome' },
        { key: 'kind', label: 'Tipo' },
      ]}
      fields={[
        { name: 'code', label: 'Código', type: 'text', required: true },
        { name: 'name', label: 'Nome', type: 'text', required: true },
        {
          name: 'kind', label: 'Tipo', type: 'select', required: true,
          options: [
            { value: 'BUILDING', label: 'Prédio' },
            { value: 'FLOOR', label: 'Andar' },
            { value: 'ROOM', label: 'Sala' },
            { value: 'SHELF', label: 'Prateleira' },
            { value: 'CART', label: 'Carro' },
            { value: 'OTHER', label: 'Outro' },
          ],
        },
        { name: 'parent_id', label: 'Local pai', type: 'entity', endpoint: '/v1/locations', displayField: 'name', secondaryField: 'code', hint: 'opcional — cria hierarquia de prédio / andar / sala' },
      ]}
    />
  );
}
